import React from "react";
import { Link } from "react-router-dom";
import MonteursPage from "../pl/Monteurs";

export default function TenantAdminUsersPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-100 via-slate-50 to-white p-4 md:p-6">
      <div className="mx-auto max-w-6xl">
        <header className="mb-6 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <p className="text-xs uppercase tracking-[0.18em] text-slate-500">Bedrijfsinrichting</p>
          <h1 className="mt-1 text-2xl font-bold text-slate-900">Gebruikersbeheer</h1>
          <p className="mt-2 text-sm text-slate-600">
            Beheer wie toegang heeft tot deze Logboek24-omgeving en hoe gebruikers operationeel inzetbaar zijn.
          </p>
          <div className="mt-3">
            <Link to="/tenant-admin" className="text-sm font-medium text-slate-700 underline underline-offset-2">
              Terug naar Bedrijfsinrichting
            </Link>
          </div>
        </header>

        <MonteursPage showPageHeader={false} />
      </div>
    </div>
  );
}
